import { useContentful } from '../../hooks/useContentful'
import * as styles from './Footer.module.scss'
import logo from '../../assets/images/MancWatchFooter.png'
import Text from '../../components/Text/Text'

const Footer = () => {
  const { contentfulData, loaded } = useContentful('footer')

  if (!loaded) {
    return null
  }
  const footerData = contentfulData.items[0].fields
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInnerContainer}>
        <div>
          <img src={logo} className={styles.footerImg} />
          <Text className={styles.footerNote}>{footerData.slogan}</Text>
          <Text className={styles.footerNote}>
            All Rights Reserved 2022 | mancwatch.co.uk
          </Text>
        </div>
      </div>
    </footer>
  )
}

export default Footer
